import { Species } from "@/data/species/types/Species";
import {
  inferDefaultActivityTags,
  isSpeciesActivityTag,
  sanitizeActivityTagsForCategory,
  type SpeciesActivityTag,
} from "@/constants/speciesActivityTags";

function pickActivityTags(
  catalog: SpeciesActivityTag[] | undefined,
): SpeciesActivityTag[] {
  return (catalog ?? []).filter(isSpeciesActivityTag);
}

/** Infer and sanitize activity tags for a species row from the Sanity catalog. */
export function enrichSpeciesActivityTags(species: Species): Species {
  const explicit = pickActivityTags(species.activityTags);
  const tags = sanitizeActivityTagsForCategory(
    explicit.length > 0
      ? explicit
      : inferDefaultActivityTags(species.category, species),
    species.category,
    species,
  );
  return { ...species, activityTags: tags };
}
